// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__fV20B","tab":"ProcedureTabs_tab__3Jvai"};